import React, { Fragment } from "react"
import { FaTimesCircle, FaCheckCircle } from "react-icons/fa"
import { useTranslation } from "react-i18next"

import { getFileSizeText } from "utils"
import { Button, Spinner } from "components"
import classes from "./FuwfCard.module.scss"
import clsx from "clsx"

const FuwfCard = props => {
  const {
    file,
    setFiles,
    setTab,
    sending,
    enableCrop,
    originalFiles,
    setSelectedFileForEdit
  } = props

  const [t, i18n] = useTranslation()

  const handleEdit = () => {
    setTab("editImage")

    setSelectedFileForEdit(file)
  }

  const handleRemove = () => {
    setFiles(prev => {
      const newFiles =
        prev.filter(f => f.id !== file.id)

      originalFiles.current = newFiles

      newFiles.length === 0 && setTab("device")

      return newFiles
    })
  }

  const handleUndo = () => {
    setFiles(prev =>
      prev.map(f =>
        f.id === file.id
          ? originalFiles.current.find(o => o.id === file.id)
          : f
      )
    )
  }

  const fileSize =
    getFileSizeText(file.size)

  const fileSizeUploadProgress =
    getFileSizeText(file.uploadProgress * file.size)

  const uploadComplete = file.uploadProgress === 1

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["container"]}>
      <img
        src={file.isFile ? file.url : `${file.url}?width=100`}
        className={classes["image"]}
        alt={file.name}
      />

      <div className={classes["right"]}>
        <div className={classes["details"]}>
          <div
            className={clsx(
              classes["image-name"],
              isLtr && classes["image-name-ltr"]
            )}
          >
            {file.name}
          </div>
          <div className={classes["image-size"]}>
            {uploadComplete
              ?
              fileSize
              :
              sending
                ? `${fileSizeUploadProgress} - ${fileSize}`
                : fileSize
            }
          </div>
        </div>

        <div className={classes["actions"]}>
          {uploadComplete
            ?
            <span className={classes["complete"]}>
              {t("آپلود_انجام_شد")}{" "}
              <FaCheckCircle />
            </span>
            :
            file.uploadFailed
              ?
              <span className={classes["failed"]}>
                {t("آپلود_انجام_نشد")}{" "}
                <FaTimesCircle />
              </span>
              :
              sending
                ?
                <div className={classes["uploading"]}>
                  <span className={classes["upload-progress"]}>
                    {(file.uploadProgress * 100) | 0}%
                  </span>
                  <Spinner
                    size={20}
                    className={classes["spinner"]}
                  />
                </div>
                :
                <Fragment>
                  {file.edited
                    ?
                    <Button
                      className={classes["button-1"]}
                      onClick={handleUndo}
                    >
                      {t("لغو_ویرایش")}
                    </Button>
                    :
                    enableCrop &&
                    <Button
                      color="success"
                      className={classes["button-1"]}
                      onClick={handleEdit}
                    >
                      {t("ویرایش")}
                    </Button>
                  }

                  <Button
                    className={classes["button-2"]}
                    color="danger"
                    onClick={handleRemove}
                  >
                    {t("حذف")}
                  </Button>
                </Fragment>
          }
        </div>
      </div>
    </div>
  )
}

export default FuwfCard